import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceToString'
})
export class PriceToStringPipe implements PipeTransform {

  transform(value: any, ...args: any[]): string {
    if (value && (typeof value.significand === 'number') && (typeof value.exponent === 'number')) {
      if (args[0] === 'flat') {
        return parseFloat((value.significand * Math.pow(10, value.exponent) * 100).toFixed(2)).toString();
      }
      return parseFloat((value.significand * Math.pow(10, value.exponent)).toFixed(2)).toString() + value.currency;
    }
    return value;
  }

}
